import { ReportSettingsTemplateListItem } from "@common/schemas/domains/reportSettings/report-settings-template.schema";
import { ReportTemplatesViewColumn } from "@common/types/views/reportTemplatesView";
import { ViewConfig } from "@lib/views";
import { ReportTemplateActionsCell } from "./cells/ReportTemplateActionsCell";
import { ReportTemplateDescriptionCell } from "./cells/ReportTemplateDescriptionCell";
import { ReportTemplateEntitiesCell } from "./cells/ReportTemplateEntitiesCell";
import { ReportTemplateNameCell } from "./cells/ReportTemplateNameCell";

export interface ReportTemplateRow extends Omit<
    ReportSettingsTemplateListItem,
    "id"
> {
    id: string;
    templateId: string | null;
}

export type ReportTemplatesViewConfig = ViewConfig<
    ReportTemplateRow,
    ReportTemplatesViewColumn,
    never
>;

export const reportTemplatesViewConfig: ReportTemplatesViewConfig = {
    columns: {
        [ReportTemplatesViewColumn.NAME]: {
            accessorKey: "name",
            name: "Template",
            header: "Template",
            cell: ReportTemplateNameCell,
            minSize: 220,
            maxSize: 1200,
            immutable: true,
        },
        [ReportTemplatesViewColumn.DESCRIPTION]: {
            accessorKey: "description",
            name: "Description",
            header: "Description",
            cell: ReportTemplateDescriptionCell,
            minSize: 200,
            maxSize: 1200,
        },
        [ReportTemplatesViewColumn.ENTITIES]: {
            accessorKey: "entities",
            name: "Entities",
            header: "Entities",
            cell: ReportTemplateEntitiesCell,
            align: "right",
            minSize: 140,
            maxSize: 320,
        },
        [ReportTemplatesViewColumn.ACTIONS]: {
            accessorKey: "id",
            name: "Actions",
            header: "",
            cell: ReportTemplateActionsCell,
            minSize: 140,
            maxSize: 140,
            immutable: true,
            hiddenFromSettings: true,
        },
    },
};
